(function()
{
	"use strict";

	function GarbageField()
	{
		this.Container_constructor();
		this.garbageField = new cjs.Container();
		this.singleSelect = 0;
		this.doubleSelect = 0;
		this.tripleSelect = 0;
		this.obstacleSelect = 0;
		this.presentSelect = 0;
		this.alpha = 0;
		this.garbageSingleArray = cm.main.garbageToCollect;
		this.garbageDoubleArray = cm.main.garbageToCollect;
		this.garbageTripleArray = cm.main.garbageToCollect;
		this.obstacleArray = ["asteroid", "asteroid"];
		this.obstacleArrayTutorial = ["asteroid", "sparkle"];
		this.presentArray = ["present"];
		this.spawnCountSingle = 0;
		this.spawnCountDouble = 0;
		this.spawnCountTriple = 0;
		this.addChild(this.garbageField);
	}

	var p = createjs.extend(GarbageField, cjs.Container);

	p.setupSpawnCount = function()
	{
		this.spawnCountSingle = this.parent.spawnCount.single;
		this.spawnCountDouble = this.parent.spawnCount.double;
		this.spawnCountTriple = this.parent.spawnCount.triple;
	};

	p.sendPresent = function()
	{
		if(cm.main.pause){return;}
		var sendingGarb = [];
		sendingGarb.push(this.presentArray[this.presentSelect]);
		var createGarbage = this.garbageSetup(sendingGarb);
		for (var i = 0, l = createGarbage.length; i < l; i++) {
		   var g = createGarbage[i];
		   g.isCollectable = true;
		   g.isObstacle = false;
		   g.score = 0;
		   this.garbageField.addChildAt(g, 0);
		   this.createSparkle(g);
		}
		this.presentSelect++;
		if(this.presentSelect > this.presentArray.length-1)
			this.presentSelect = 0;
	};

	p.sendObstacleTutorial = function()
	{
		if(cm.main.pause){return;}
		var sendingObstacle = [];
		var i, l, sprite;
		for (i = 0, l = 2; i < l; i++) {
				sprite = this.obstacleArrayTutorial[i];
				sendingObstacle.push(sprite);
		}
		var createObstacle = this.garbageSetup(sendingObstacle);
		for (i = 0, l = createObstacle.length; i < l; i++) {
			var g = createObstacle[i];

			if(i>0){
				g.rt = -1;
				g.vx *= 0.5;
				g.vy *= 0.5;
				g.vz = 39.5;
				g.name = "sparkle";
			}else{
				g.vx *= 0.5;
				g.vy *= 0.5;
				g.rt = 1;
				g.vz = 40;
			}
			g.isCollectable = false;
			g.isTutorial = true;
			g.isObstacle = true;
			this.garbageField.addChildAt(g, 0);
		 }
		 this.obstacleSelect++;
		if(this.obstacleSelect > this.obstacleArray.length-1)
			this.obstacleSelect = 0;
	};

	p.sendObstacle = function()
	{
		if(cm.main.pause){return;}
		var sendingObstacle = [];
		sendingObstacle.push(this.obstacleArray[this.obstacleSelect]);
		var createObstacle = this.garbageSetup(sendingObstacle);
		for (var i = 0, l = createObstacle.length; i < l; i++) {
			var g = createObstacle[i];
			g.vx *= 0.5;
			g.vy *= 0.5;
			g.isCollectable = false;
			g.isObstacle = true;
			this.garbageField.addChildAt(g, 0);
		 }
		 this.obstacleSelect++;
		if(this.obstacleSelect > this.obstacleArray.length-1)
			this.obstacleSelect = 0;
	};

	p.createSparkle = function(garbage)
	{
		var sparkleContainer = new cjs.Container();
		for (var i = 0, l = 10; i < l; i++) {
			var sparkle = new cjs.Sprite(cm.Assets.lib.gameSS, "particle").center();
			sparkle.x  = Math.range(-100, 100);
			sparkle.y = Math.range(-100, 100);
			sparkle.alpha = sparkle.scaleY = sparkle.scaleX = 0;
			var randomWait = Math.range(1000, 4000);
			var randomSpeed = Math.range(150, 400);
			var ranScale = Math.range(1, 3);

			new cjs.Tween.get(sparkle, {loop: true}).wait(randomWait).to({alpha:1, scaleX:ranScale, scaleY:ranScale}, randomSpeed).to({alpha:0, scaleX:0, scaleY:0}, randomSpeed);
			sparkleContainer.addChild(sparkle);
		}
		sparkleContainer.scaleX = sparkleContainer.scaleY = 0;
		this.garbageField.addChild(sparkleContainer);
		garbage.particle = sparkleContainer;
	};

	p.sendSingleGarbage = function()
	{

		if(cm.main.pause){return;}
		if(this.spawnCountSingle<1){return;}
		this.spawnCountSingle--;
		var sendingGarb = [];
		sendingGarb.push(this.garbageSingleArray[this.singleSelect]);
		var createGarbage = this.garbageSetup(sendingGarb);
		for (var i = 0, l = createGarbage.length; i < l; i++) {
		   var g = createGarbage[i];
		   g.isCollectable = true;
		   g.isObstacle = false;
		   g.score = 1;
		   this.garbageField.addChildAt(g, 0);
		   this.createSparkle(g);
		}
		this.singleSelect++;
		if(this.singleSelect > this.garbageSingleArray.length-1)
			this.singleSelect = 0;
	};

	p.sendDoubleGarbage = function ()
	{

		if(cm.main.pause){return;}
		if(this.spawnCountDouble<1){return;}
		this.spawnCountDouble--;
		var sendingGarb = [];
		var i, l, sprite;
		for (i = 0, l = 2; i < l; i++) {

			if (cm.main.gameSettings.grapple > 1){
				sprite = this.garbageDoubleArray[this.doubleSelect];
				this.doubleSelect++;
				if(this.doubleSelect > this.garbageDoubleArray.length-1)
					this.doubleSelect = 0;
			}
			else{
				sprite = this.garbageDoubleArray[i] + "-grayed";
			}

			sendingGarb.push(sprite);
		}

		var createGarbage = this.garbageSetup(sendingGarb);
		for (i = 0, l = createGarbage.length; i < l; i++) {
			var g = createGarbage[i];
			if (cm.main.gameSettings.grapple > 1){
				g.isCollectable = true;
				g.isObstacle = false;
				this.createSparkle(g);
			}
			else{
				g.isCollectable = false;
			}
			g.score = 2;
			this.garbageField.addChildAt(g, 0);
		}
	};

	p.sendTripleGarbage = function ()
	{

		if(cm.main.pause){return;}
		if(this.spawnCountTriple<1){return;}
		this.spawnCountTriple--;
		var sendingGarb = [];
		var i, l, sprite;
		for (i = 0, l = 3; i < l; i++) {
			if (cm.main.gameSettings.grapple > 2){
				sprite = this.garbageTripleArray[this.tripleSelect];
				this.tripleSelect++;
				if(this.tripleSelect > this.garbageTripleArray.length-1)
					this.tripleSelect = 0;

			}
			else{
				sprite = this.garbageTripleArray[i] + "-grayed";
			}

			sendingGarb.push(sprite);
		}

		var createGarbage = this.garbageSetup(sendingGarb);
		for (i = 0, l = createGarbage.length; i < l; i++) {
			var g = createGarbage[i];
			if (cm.main.gameSettings.grapple > 2) {
				g.isCollectable = true;
				g.isObstacle = false;
				this.createSparkle(g);
			}
			else {
				g.isCollectable = false;
			}
			g.score = 3;
			this.garbageField.addChildAt(g, 0);
		}
	};

	p.garbageSetup = function(garbage)
	{
		if(cm.main.pause){return;}
		var returningArray = [];
		var fl = 250;

		var w = 900 / 2;
		var h = 384 / 2;
		var scale = fl / (fl + 5000);
		var d = Math.random() * 35 + 5;
		var a = Math.random() * Math.PI * 2;
		var posX = Math.range(-w, w) * scale;
		var posY = Math.range(-h, h) * scale;
		var vz = 40;

		for (var i = 0, l = garbage.length; i < l; i++) {
			var bmp = new cjs.Sprite(cm.Assets.lib.junkSS, garbage[i]).center();
			bmp.z = 5000;
			bmp.posZ = bmp.z;
			bmp.scaleX = bmp.scaleY = scale;
			bmp.randomAlpha = 1;
			bmp.alpha = 0;
			bmp.posX = posX;
			bmp.posY = posY;
			bmp.x = bmp.posX;
			bmp.y = bmp.posY;
			bmp.vx = Math.cos(a) * d;
			bmp.vy = Math.sin(a) * d;
			bmp._x = bmp.posX;
			bmp._y = bmp.posY;
			bmp.vz = vz;
			bmp.rt =  Math.random() < 0.5 ? -1 : 1;
			returningArray.push(bmp);
		}
		return returningArray;
	};

	p.moveGarbageField = function ()
	{
		if(cm.main.pause){return;}
		var l = this.garbageField.numChildren;
		var fl = 1000;

		for (var i = l - 1; i >= 0; i--) {
			var bmp = this.garbageField.getChildAt(i);
			var scale = fl / (fl + bmp.z);
			bmp._x += bmp.vx;
			bmp._y += bmp.vy;
			bmp.z -= bmp.vz * cm.main.speed* 0.5;
			bmp.x = bmp._x * scale * 0.1;
			bmp.y = bmp._y * scale * 0.03;
			bmp.scaleX = scale;
			bmp.scaleY = scale;
			//particle stuff
			if(bmp.particle){
				bmp.particle.x =  bmp.x;
				bmp.particle.y = bmp.y;
				bmp.particle.scaleX =  bmp.scaleX;
				bmp.particle.scaleY = bmp.scaleY;
			}


			bmp.rotation += bmp.rt;
			if(bmp.z < 4000){
				if(bmp.alpha < bmp.randomAlpha)
					bmp.alpha += 0.01;
			}
			if(bmp.z < 1000 && bmp.z > 500)
				this.parent.checkGarbageCollision(bmp);
			if(bmp.z < 500){
				if(bmp.particle){
					this.garbageField.removeChild(bmp.particle);
				}

				this.parent.missedGarbageContainer.addChildAt(bmp, 0);
			}

		}
	};

	p.moveMissedGarbage = function()
	{
		if(cm.main.pause){return;}
		var l = this.parent.missedGarbageContainer.numChildren;
		var fl = 1000;

		for (var i = l - 1; i >= 0; i--) {
			var bmp = this.parent.missedGarbageContainer.getChildAt(i);
			var scale = fl / (fl + bmp.z);
			bmp._x += bmp.vx;
			bmp._y += bmp.vy;
			bmp.z -= bmp.vz * cm.main.speed* 0.5;
			bmp.x = bmp._x * scale * 0.1;
			bmp.y = bmp._y * scale * 0.03;
			bmp.scaleX = scale;
			bmp.scaleY = scale;

			bmp.rotation += bmp.rt;
			if(bmp.z < 1000 && bmp.z > 500)
				this.parent.checkGarbageCollision(bmp);
			if (bmp.z < -1000) {
				if(bmp.isCollectable)
					this.parent.collectableItems++;
					this.parent.checkEndLevel();

				this.removeGarbage(bmp);
			}
		}
	};

	p.removeGarbage = function(garbage)
	{
		this.parent.missedGarbageContainer.removeChild(garbage);
	};

	cm.GarbageField = cjs.promote(GarbageField, "Container");
})();
